import { ApplicationFormLayout, MainLayout } from 'layouts';
import { OoApplicationViewPage } from 'pages/OoApplicationViewPage';
import { useIsOoCaseNewUiEnabled } from 'providers/PosthogProvider';
import { LegacyApplicationDetailsPage } from './LegacyApplicationDetailsPage';

export { ApplicationDetailsTab } from './LegacyApplicationDetailsPage';
export type { ApplicationDetailsTabValue } from './LegacyApplicationDetailsPage';

export const ApplicationDetailsPage = () => {
  const isOoCaseNewUiEnabled = useIsOoCaseNewUiEnabled();

  if (isOoCaseNewUiEnabled) {
    return (
      <ApplicationFormLayout>
        <OoApplicationViewPage />
      </ApplicationFormLayout>
    );
  }

  return (
    <MainLayout>
      <LegacyApplicationDetailsPage />
    </MainLayout>
  );
};
